import React, { Component } from 'react';
import { COLORS } from '../styles';
import anime from 'animejs';

const MIN_TRANSLATION = 100;
const MAX_TRANSLATION = 250;

class Confetti extends Component {
  confetti = null;

  componentDidMount() {
    this.startAnimation();
  }

  startAnimation() {
    if (this.confetti) {
      const left = `${Math.random() * 100}%`;
      const animationLength = Math.floor((Math.random() * 6000) + 2000);
      const translationAmount = Math.floor(Math.random() * (MAX_TRANSLATION - MIN_TRANSLATION)) + MIN_TRANSLATION;
      const color = Math.floor(Math.random() * 11);
      const backgroundColor = color <= 5 ? COLORS[color] : '#efefef';

      // Set initial style
      this.confetti.style.left = left;
      this.confetti.style.backgroundColor = backgroundColor;
      this.confetti.style.transform = 'translateY(-40px)';
      this.confetti.style.opacity = 1;

      // try {
      //   this.confetti.animate([
      //     {transform: 'translate(0, -40px)', opacity: 1},
      //     {opacity: 1},
      //     {opacity: 1},
      //     {transform: `translate(0, ${translationAmount}px)`, opacity: 0}
      //   ], animationLength);
      // } catch (e) {

      // }
      anime({
        targets: this.confetti,
        translateY: translationAmount,
        opacity: {
          value: 0,
          duration: 500,
          delay: animationLength - 500
        },
        easing: 'easeInQuad',
        duration: animationLength
      });

      setTimeout(this.startAnimation.bind(this), animationLength);
    }
  }

  render() {
    return (
      <div
        ref={ref => this.confetti = ref}
        className="confetti"
      >
      </div>
    );
  }
}

export default Confetti;


// WEBPACK FOOTER //
// ./src/components/Confetti.js